import React from "react";
import { WheelSVG } from "./WheelSVG";
import { UPGRADES, getCurrentEraKey } from "../game/constants";

// Card showing the current era + progress dots (X / 12).
export const EraCard = ({ upgrades, seenEras }) => {
  const eraKey = getCurrentEraKey(upgrades);
  const currentUpgrade =
    UPGRADES.find((u) => u.eraKey === eraKey) || null;
  const seenCount = Object.keys(seenEras || {}).length;
  const total = UPGRADES.length;
  const label = currentUpgrade ? currentUpgrade.name : "Empty Hands";

  return (
    <div
      className="w-full max-w-md relative p-3 sm:p-4 flex items-center gap-3 sm:gap-4"
      style={{
        backgroundColor: "#0d0d0d",
        border: "1px solid #2a2a2a",
        borderRadius: 4,
      }}
      data-testid="era-card"
    >
      <div
        className="flex-shrink-0 w-14 h-14 sm:w-16 sm:h-16 p-1.5"
        style={{ border: "1px solid #FFD400", borderRadius: 2, backgroundColor: "#111" }}
      >
        <WheelSVG eraKey={eraKey} />
      </div>
      <div className="flex-1 min-w-0">
        <div
          className="text-[10px] uppercase tracking-[0.35em] text-white/50"
          style={{ fontFamily: "Orbitron, sans-serif" }}
        >
          Current Era
        </div>
        <div
          className="text-base sm:text-lg font-black uppercase tracking-widest text-white truncate"
          style={{ fontFamily: "Orbitron, sans-serif" }}
          data-testid="era-card-name"
        >
          {label}
        </div>
        <div className="mt-2 flex items-center gap-1.5">
          {UPGRADES.map((u, i) => {
            const owned = (upgrades[u.id] || 0) >= 1;
            const isCurrent = currentUpgrade && u.id === currentUpgrade.id;
            return (
              <span
                key={u.id}
                aria-hidden
                className="block"
                style={{
                  width: isCurrent ? 10 : 6,
                  height: isCurrent ? 10 : 6,
                  borderRadius: 999,
                  backgroundColor: owned ? "#FFD400" : "#2a2a2a",
                  boxShadow: isCurrent ? "0 0 8px #FFD400" : "none",
                  transition: "background-color 200ms",
                }}
                data-idx={i}
              />
            );
          })}
        </div>
      </div>
      <div
        className="text-xs uppercase tracking-widest text-white/60"
        style={{ fontFamily: "Orbitron, sans-serif" }}
        data-testid="era-card-progress"
      >
        {seenCount}/{total}
      </div>
    </div>
  );
};

export default EraCard;
